<template>
  <n-modal class="card-record" :loading="$var('load')" @close="$emit('close')">
    <h2>
      Запись в журнале
      <span v-if="edit.records" style="float: right; font-size: .8rem"><n-button icon="trash" @click="remove" /></span>
    </h2>
    <div class="body">
      <div class="object">Проект: {{ project.title }}</div>
      <div>Дата: {{ $app.date.format(record.publishedAt) }}</div>
      <div>Статус: {{ utils.status(record.status) }}</div>
      <div>Автор: {{ record.author.fullName }}</div>


      <n-button v-if="edit.records && !checkIfSignIsExist(user.id, 'records')" @click="$var('acceptRec', true)">Подписать</n-button>
    </div>
    <br />
    <n-items>
      <n-input title="смена" v-bind="$form.input('date')" :text="!edit.records" />
      <n-input title="Наименование работ и применяемых материалов (пооперационно)" v-bind="$form.input('title')" :text="!edit.records" />
      <n-input title="Объём работ" v-bind="$form.input('workValue')" :text="!edit.records" />
      <n-input title="Температура во время выполнения работ, С: на поверхности материала" v-bind="$form.input('tempTop')" :text="!edit.records" />
      <n-input title="Температура во время выполнения работ, С: окружающего воздуха на расстоянии не более 1 м от поверхности" v-bind="$form.input('tempAir')" :text="!edit.records" />
      <n-input title="Применяемые материалы: ГОСТ, ОСТ, ТУ" v-bind="$form.input('materialGost')" :text="!edit.records" />
      <n-input title="Применяемые материалы номер: паспорта" v-bind="$form.input('passportNumber')" :text="!edit.records" />
      <n-input title="Применяемые материалы номер: анализа" v-bind="$form.input('analyzeNumber')" :text="!edit.records" />
      <n-input title="Число нанесённых слоёв и их толщина, мм" v-bind="$form.input('layers')" :text="!edit.records" />
      <n-input title="Температура, С, и продолжительность сушки отдельных слоёв покрытия" v-bind="$form.input('tempLayer')" :text="!edit.records" />
      <n-input title="Фамилия и инициалы бригадира (специалиста), выполнявшего защитное покрытие" v-bind="$form.input('foreman')" :text="!edit.records" />
      <n-input title="Дата и номер акта освидетельствования выполненных работ" v-bind="$form.input('dateAkt')" :text="!edit.records" />
      <n-input title="Примечание" v-bind="$form.input('remark')" :text="!edit.records" />
    </n-items>

    <br />
    <n-divide>
      <n-button v-if="edit.records" color="success" @click="save()">Сохранить</n-button>
      <n-button @click="$emit('close')">Закрыть</n-button>
    </n-divide>

    <c-modal-journal-do-sign v-if="$var('acceptRec')" @close="$var('acceptRec', false)" @submit="(s) => accept('records', s)" />
  </n-modal>
</template>

<script>
import utils from 'utils'
import CModalJournalDoSign from 'components/journal/ModalDoSign'

export default {
  name: 'ModalRecord',
  components: { CModalJournalDoSign, },
  props: [ 'project', 'journal', ],
  data() {
    return {
      utils,
      record: { author: {}, },
      user: $app.auth.user(),
      tabs: [
        { name: 'info', title: 'Информация', callback: this.save, },
        { name: 'control', title: 'Проверяющие', },
      ],
      columns: [
        { title: 'Название', name: 'title', },
        { title: 'Расход', name: 'done', },
      ],
      translates: {
        attach: 'Приложения',
        schema: 'Исполнительные схемы',
        figure: 'Чертежи',
        input: 'Документы',
      },
    }
  },
  computed: {
    id() {
      return this.$route.query.show
    },
    edit() {
      return {
        records: $app.auth.can('journals_'+this.journal.name+'_records', this.project.id) && this.record.status === 'formed',
      }
    },
  },
  watch: {
    '$route.query.id'() {
      this.load()
    },
  },
  created() {
    this.load()
    this.$form.init({})
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, this.journal.name, this.id).query({
        'with[author][with][participation]': null,
        'with[signs][with][author]': null,
        projectId: this.project.id,
      }).then((result) => {
        this.record = result.data.content
        this.$form.init(this.record)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    remove() {
      this.$var('load', true)
      $api.journals.records.remove(this.journal.name, this.record.id).then(() => {
        this.load()
        this.$emit('close')
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    save() {
      this.$var('load', true)
      $api.journals.spec55.edit(this.record.id, this.$form.get()).then(() => {
        this.load()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    accept(name, sign) {
      this.$var('load', true)
      $api.journals.spec55.accept(this.record.id, { name, sign, }).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    checkIfSignIsExist(userId, signName) {
      let isExist = false
      if (this.record) {
        if (this.record.signs) {
          $n.each(this.record.signs, (el) => {
            if (el.authorId !== null || el.isApproved) {
              if (el.name === signName && el.authorId === userId && el.isApproved) {
                isExist = true
              }
            }
          })
        }
      }
      return isExist
    },
  },
}
</script>

<style lang="scss" scoped>
.card-record {
  
  .weather {
    .env, .temperature, .wind {
      width: 150px;
      margin-right: 20px;
    }
  }
  

}
</style>
